module.exports = __webpack_public_path__ + "img/dd-logo-honda2.07deccd4.png";